import { MedicineIcd } from '../interfaces/medicine';

export const normalizeMedicineIcd = (medicineIcd?: MedicineIcd | null): MedicineIcd | undefined => {
  return medicineIcd || undefined;
};
